import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const InfoBlockTwo = () => {
  return (
  <div id="Speakers" className="info-card-block">
    <div className="logo-container">
    <StaticImage
      src="../assets/csicon-26-logo-clean.png"
      alt="CSICon 2026 50th"
      className="csicon-26-logo-clean"
    />
  </div>
     <ul className="names-grid">
        <li className="name-item name-highlight">JAMES ALCOCK</li>
        <li className="name-item name-highlight">BANACHEK</li>
        <li className="name-item">MEAGAN ANKNEY</li>
        <li className="name-item">KENNY BIDDLE</li>
        <li className="name-item">TIMOTHY BINGA</li>
        <li className="name-item">EVAN BERNSTEIN</li>
        <li className="name-item">ROBYN BLUMNER</li>
        <li className="name-item">ALEJANDRO BORGO</li>
        <li className="name-item name-highlight">BRIAN BRUSHWOOD</li>
        <li className="name-item name-highlight">PERRY CARPENTER</li>
        <li className="name-item name-highlight">BRIAN DUNNING</li>
        <li className="name-item">MICHAEL EDWARDS</li>
        <li className="name-item">RUTH FRAZIER</li>
        <li className="name-item">SUSAN GERBIC</li>
        <li className="name-item">RAYMOND HALL</li>
        <li className="name-item name-highlight">PETER HOTEZ</li>
        <li className="name-item">STEPHEN HUPP</li>
        <li className="name-item">GEORGE HRAB</li>
        <li className="name-item">LEO IGWE</li>
        <li className="name-item">BARRY KARR</li>
        <li className="name-item">SCOTT HAMILTON KENNEDY</li>
        <li className="name-item">RONALD LINDSAY</li>
        <li className="name-item name-highlight">LEIGHANN LORD</li>
        <li className="name-item">ANDREA LOVE</li>
        <li className="name-item">MALORIE MACKEY</li>
        <li className="name-item name-highlight">MICHAEL MANN</li>
        <li className="name-item name-highlight">CARA SANTA MARIA</li>
        <li className="name-item">JAY NOVELLA</li>
        <li className="name-item">ROBERT NOVELLA</li>
        <li className="name-item name-highlight">STEVEN NOVELLA</li>
        <li className="name-item name-highlight">BILL NYE</li>
        <li className="name-item">ROB PALMER</li>
        <li className="name-item">BEN RADFORD</li>
        <li className="name-item name-highlight">RINA RAPHAEL</li>
        <li className="name-item">DANIEL REED</li>
        <li className="name-item name-highlight">MARY ROACH</li>
        <li className="name-item">AMARDEO SARMA</li>
        <li className="name-item name-highlight">RICHARD SAUNDERS</li>
        <li className="name-item name-highlight">EUGENIE SCOTT</li>
        <li className="name-item">KATIE SULETA</li>
        <li className="name-item">EDDIE TABASH</li>
        <li className="name-item">NICK TILLER</li>
        <li className="name-item name-highlight">MELANIE TRECEK-KING</li>
        <li className="name-item name-highlight">ANTHONY TRECEK-KING</li>
        <li className="name-item">JIM UNDERDOWN</li>
        <li className="name-item">BERTHA VAZQUEZ</li>
        <li className="name-item">STUART VYSE</li>
        <li className="name-item">DAN WILSON</li>
        <li className="name-item name-highlight">RICHARD WISEMAN</li>
        <li className="name-item">JUSTIN ROBERT YOUNG</li>
        <li className="name-item">ZHANG ZHIMIN</li>
      </ul>

  </div>

  )
}



export default InfoBlockTwo
